import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  // Set a fixed end time for demonstration (e.g., end of current day)
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center gap-2 font-body font-bold text-orange-warm ${className}`} data-id="element-19">
      <div className="flex flex-col items-center" data-id="element-20">
        <span className="bg-white/20 px-2 py-1 rounded text-lg md:text-xl" data-id="element-21">
          {format(timeLeft.hours)}
        </span>
        <span className="text-[10px] uppercase mt-1" data-id="element-22">Horas</span>
      </div>
      <span className="text-xl -mt-4" data-id="element-23">:</span>
      <div className="flex flex-col items-center" data-id="element-24">
        <span className="bg-white/20 px-2 py-1 rounded text-lg md:text-xl" data-id="element-25">
          {format(timeLeft.minutes)}
        </span>
        <span className="text-[10px] uppercase mt-1" data-id="element-26">Min</span>
      </div>
      <span className="text-xl -mt-4" data-id="element-27">:</span>
      <div className="flex flex-col items-center" data-id="element-28">
        <span className="bg-white/20 px-2 py-1 rounded text-lg md:text-xl" data-id="element-29">
          {format(timeLeft.seconds)}
        </span>
        <span className="text-[10px] uppercase mt-1" data-id="element-30">Seg</span>
      </div>
    </div>;
}